import React, { Component } from 'react';
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import ShowTask from '../tasksCard/ShowTask'

class TasksItems extends Component {
    constructor(props){
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            modal: false,
            showPopoverLabels: false,
            isLoadedShow: true,
            id: "",
            task: {},
            dataShow: {},
        }
    }

    toogle = (from) => {
        console.log("abriendo el módulos de tareas toogletoogletoogle")
        if (from == "new") {
            this.setState({ modal: true })
        } else {
            this.setState({ modal: false, task: {} })
        }
    }


    editState = (id, state) => {
        fetch(`/task/update_state/${id}/${state}`, {
            method: 'PATCH', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.props.loadData();
        });
    }

    delete = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/task/tasks/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.props.loadData()
                    });
            }
        });
    };


    loadDataShow = (id) => {
        fetch(`/task/get_show_taks/${id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    dataShow: data.data,
                    isLoadedShow: false
                });
            });
    }


    editTask = (tarea) => {
        this.setState({
            modal: true,
            task: tarea
        })
    }

    stateLabel = (state) => {
        const map = { to_do: "Por hacer", doing: "En proceso", done: "Hecho", filed: "Archivada" };
        return map[state] || "";
    }

    stateStyle = (state) => {
        const map = {
            to_do: { bg: "#e0e7ff", fg: "#3730a3", bd: "#c7d2fe" },
            doing: { bg: "#fef3c7", fg: "#92400e", bd: "#fde68a" },
            done:  { bg: "#d1fae5", fg: "#065f46", bd: "#a7f3d0" },
            filed: { bg: "#e5e7eb", fg: "#374151", bd: "#d1d5db" },
        };
        return map[state] || { bg: "#eef2ff", fg: "#3730a3", bd: "#c7d2fe" };
    }


    render() {
        const task = this.props.task;
        const modal = this.state.modal && (
            <ShowTask
                backdrop={"static"}
                modal={this.state.modal}
                toggle={this.toogle}
                title={"Crear tarea"}
                task={this.state.task}
                loadTasks={this.loadDataShow}
                users={this.props.users}
                isLoadedShow={false}
                user={this.props.user}
                loadData={this.props.loadData}
                updateItem={this.props.updateItem}
                procesos={this.props.procesos}
                company={this.props.company}
                imageUpload={this.props.imageUpload}
                key_text={this.props.key_text}
            />
        );

        const label = this.stateLabel(task.state);

        if (this.props.compact) {
            const c = this.stateStyle(task.state);
            return (
                <React.Fragment>
                    {modal}
                    <span
                        className="cause-task-chip"
                        title={`${task.name}${label ? " (" + label + ")" : ""}`}
                        style={{
                            display: "inline-flex", alignItems: "center", gap: "5px",
                            maxWidth: "200px", background: c.bg, border: `1px solid ${c.bd}`,
                            borderRadius: "999px", padding: "2px 10px", fontSize: "12px", lineHeight: "1.5",
                        }}
                    >
                        <span
                            onClick={() => this.editTask(task)}
                            style={{
                                color: c.fg, cursor: "pointer", fontWeight: 600,
                                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                            }}
                        >
                            {task.name}
                        </span>
                        {label && <span style={{ color: c.fg, opacity: .7, fontSize: "10px", flex: "none" }}>({label})</span>}
                        <i
                            className="fas fa-trash-alt"
                            onClick={() => this.delete(task.id)}
                            style={{ color: "#ef4444", cursor: "pointer", flex: "none", fontSize: "10px", opacity: .75 }}
                        ></i>
                    </span>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {modal}
                <li>
                    <span className="link-line taks-item" onClick={() => this.editTask(task)}>
                        {task.name} <i className="fas fa-lock-open"></i>
                    </span>
                    <i style={{ color: "red", cursor: "pointer" }} onClick={() => this.delete(task.id)} className="fas fa-trash-alt ml-2"></i>
                </li>
            </React.Fragment>
        );
    }
}

export default TasksItems;
